import { render } from "./add-empower.vue?vue&type=template&id=72414fd9&scoped=true"
import script from "./add-empower.vue?vue&type=script&lang=js"
export * from "./add-empower.vue?vue&type=script&lang=js"

import "./add-empower.vue?vue&type=style&index=0&id=72414fd9&scoped=true&lang=scss"

import exportComponent from "D:\\peizhe_protal\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72414fd9"]])

export default __exports__